<script>
  import editorInstance from '../../lib/editor/editor';
  import ModuleBlock from './Modules/ModuleBlock.svelte';
  import TextElements from './Modules/TextElements/TextElements.svelte';
  import CaptionEditor from './Modules/CaptionEditor/CaptionEditor.svelte';
  import DisplayToggle from './Modules/DisplayToggle/DisplayToggle.svelte';
  import {higlightCaptionComponent} from './sidebar-helpers';

  const advancedComponents = [
    {
      title: 'Captions',
      titleComponents: [{component: DisplayToggle, args: {target: '[data-amelement="caption"]'}}],
      component: {
        component: CaptionEditor,
        args: {
          target: '[data-amelement="caption"] .dynamic',
          reactTarget: '[data-amelement="caption"]'
        }
      },
      onMouseOver: () => higlightCaptionComponent(),
      onMouseLeave: () => editorInstance.ui.removeHighlight()
    },
    {
      component: TextElements,
      open: true,
      expandable: false,
      nobg: true
    }
  ];
</script>

<div class="grid w-full gap-3">
  {#each advancedComponents as component}
    <ModuleBlock {...component} />
  {/each}
</div>
